import React from "react";

interface IconIProps {
  size?: string;
}

const FullScreen = ({ size = "24" }: IconIProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#F7F8F8" />
      <path
        d="M5.3335 18.6666V14.4999H6.16683V17.2433L9.16683 14.2433L9.75683 14.8333L6.75683 17.8333H9.50016V18.6666H5.3335ZM14.5002 18.6666V17.8333H17.2435L14.2435 14.8333L14.8335 14.2433L17.8335 17.2433V14.4999H18.6668V18.6666H14.5002ZM9.16683 9.75658L6.16683 6.75659V9.49992H5.3335V5.33325H9.50016V6.16659H6.75683L9.75683 9.16659L9.16683 9.75658ZM14.8335 9.75658L14.2435 9.16659L17.2435 6.16659H14.5002V5.33325H18.6668V9.49992H17.8335V6.75659L14.8335 9.75658Z"
        fill="#28333A"
      />
    </svg>
  );
};
export default FullScreen;
